import config from 'config'
import { AuthParams } from 'types/auth'

const HAS_CONSENT_ATTRIBUTE_NAME = 'has_consent' // This is hardcoded as the id for some reason

export const getDefaultAuthParams = (orgId: number): AuthParams => ({
  org_id: orgId,
  client_id: config.CLIENT_ID,
  consent_id: HAS_CONSENT_ATTRIBUTE_NAME
})
